import moment from "moment";

import { IActData } from "./hooks/useCreateKs2";

export const initialCreateKsData = {
  dateEnd: moment().format("YYYY-MM-DD"),
  dateStart: moment().format("YYYY-MM-DD"),
} as IActData;
